<div *ngIf="newAnalyses.length" class="gmb-48">
  <h6 class="h7-bold gmt-36 gmb-12 gmb-sm-16">
    {{ 'ANALYSES.NEW.TEXT' | translate }}
  </h6>

  <div *ngFor="let analysis of newAnalyses" class="gmb-12">
    <app-analysis-link
      [analysis]="analysis"
      [type]="type"
      [hideCircles]="hideCircles"
    ></app-analysis-link>
  </div>
</div>
